// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldOrderTotal";
import DollarSign from "@insite/mobius/Icons/DollarSign";
import { TextFieldProps } from "@insite/mobius/TextField";
import myAccountFilterSectionStyles from "@sc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

orderTotalStyles.textField = {
    maxLength: 6,
    mergeCss: true,
    iconProps: {
        src: DollarSign,
        css: css`
            &&& {
                left: 1px; // Border left
                right: unset;
                width: 28px;
            }
        `,
    },
    cssOverrides: {
        inputSelect: css`
            padding-left: 32px;
            padding-right: 8px;

            &:focus {
                padding-left: 32px;
            }
        `,
    },
} as TextFieldProps;

orderTotalStyles.wrapper = {
    wrapper: {
        ...mergeWithCss(myAccountFilterSectionStyles.searchFieldWrapper, {
            css: css`
                flex: 1;
            `,
        }),
    },
};
